import React from 'react';
import styles from './App.css'; // Adjust the path as needed
import HolyNames from './ReisheiTevotCitations';
import GematriaCalculator from './GematriaTextConvert'
import Gematria from './FindWordsbyGematria';
import Acrostic from './AcrosticFunction-new';
import TorahCode from './TorahCode.js';
import GematriaCalculatorAtbash from './GematriaAtbash';
const TorahTools = () => {
  


  return (
      <div className="App">
        <h1 className={styles.domainCategory}>Torah Tools</h1>
        <HolyNames />
        <GematriaCalculator />
        <GematriaCalculatorAtbash />
        <Gematria />
        <TorahCode />
        
    
      </div>
    );
    
};

export default TorahTools;